import { EnvVariables } from 'src/types/model';

export const getEnvVariables = (): EnvVariables => {
  return {
    resizeImages: process.env.RESIZE_IMAGES || '',
    turnstileSiteKey: process.env.TURNSTILE_SITE_KEY || '',
    pdfBaseUrl: process.env.PDF_BASE_URL || '',
    pdfBaseUrlEastasia: process.env.PDF_BASE_URL_EASTASIA || '',
    pdfPrintServerUrl: process.env.PDF_PRINT_SERVER_URL || '',
  };
};
